import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getisFirstPage } from "../store/mycustomers";
import homepageBackground from "../logos/common/homepage-background.png"
import { getBrokerInformation } from "../store/broker";
import * as theme from "../theme";

const FullScreenDiv = (props) => {
  const isFirstPage = useSelector(getisFirstPage)
  const [style, setStyle] = useState({
    width: "100vw",
    height: "100vh",
    overflow: "hidden",
    backgroundColor: theme.COLORS.tertiary_lightbackground,
  });
  const brokerInfo = useSelector(getBrokerInformation);
  useEffect(() => {
    // Check if the current path starts with the given path segment
    if (window.location.pathname.startsWith("/customPdf/")) {
      setStyle((prevStyle) => ({ ...prevStyle, height: undefined }));
    }
    console.log("window.location.pathname: ", window.location.pathname)
    if (window.location.pathname == "/" && isFirstPage && brokerInfo.istokenvalid ) {
      console.log("We are on homePage");
      setStyle((prevStyle) => ({ 
        ...prevStyle, 		// 
        backgroundImage: `url(${homepageBackground})`, // Add background image
        backgroundSize: '100% 100%', // Adjusts image to cover the container
        backgroundPosition: 'center', // Centers the image
        backgroundRepeat: 'no-repeat', // Prevents image repetition
        minHeight: '100vh', // Full viewport height
        width: '100vw', // Full viewport width
        position: 'relative', // Required for the pseudo-element overlay
        margin: 0, // Remove default margins
        boxSizing: 'border-box', // Ensure padding doesn't affect size
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          // backgroundColor: 'rgba(255, 255, 255, 0.7)', // Semi-transparent white overlay
          zIndex: 1, // Place the overlay above the background image
        },
        '& > *': {
          position: 'relative',
          zIndex: 2, // Ensure content is above the overlay
          }
      }));
    }
    else {
      setStyle({
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: theme.COLORS.tertiary_lightbackground,
      })
    }
  
  }, [isFirstPage, window.location.pathname, brokerInfo.istokenvalid]);

  return <div style={style}>{props.children}</div>;
};

export default FullScreenDiv;
